export const DDV = "DDV";
export const TDV = "TDV";
